// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledButton } from "@insite/mobius/Clickable";
import { IconWrapper } from "@insite/mobius/Icon";
import { StyledTypography } from "@insite/mobius/Link";
import { LoadingSpinnerStyle } from "@insite/mobius/LoadingSpinner";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { getProp } from "@insite/mobius/utilities";
import { headerStyles } from "@synd/Overrides/Pages/Header";
import { DivWrapper } from "@synd/XDL/constants";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { color, companyLogoItem, layoutContainer, xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

headerStyles.page = {
    fullWidth: [true, true, true, true, true],
    padding: 0,
    css: css`
        position: sticky;
        top: 0;
        z-index: ${getProp("theme.zIndex.header")};
        box-shadow: 0 1px 0 0 ${color("common.border")};
        ${xScreen("lte", "md")} {
            position: sticky;
            overflow: unset;
        }
        ${LoadingSpinnerStyle} {
            position: absolute;
            display: none;
        }
    `,
};

headerStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        position: relative;
        ${xScreen("lte", "md")} {
            flex-direction: row-reverse;
            align-items: center;
            gap: 24px;
            ${layoutContainer}
        }
    `,
};

headerStyles.logo = {
    css: css`
        align-self: center;
    `,
};

headerStyles.search = {
    css: css`
        width: 507px;
        ${xScreen("lte", "lg")} {
            width: 430px;
        }
        ${xScreen("lte", "md")} {
            width: fit-content;
            flex: unset;
        }
    `,
};
headerStyles.secondaryMainNavigation = {
    css: css`
        ${layoutContainer}
        display: flex;
        align-items: center;
        margin-top: 1px;

        & > ${DivWrapper} {
            .item-wrapper {
                display: flex;
                align-items: center;
                ${StyledTypography} {
                    font-weight: ${fontConfig.weight.regular};
                    text-transform: uppercase;
                }
            }
            .item-wrapper + .item-wrapper:before {
                content: "";
                display: block;
                width: 1px;
                height: 24px;
                background-color: ${color("common.ui3")};
                margin: 0 4px;
            }
            .menu-item {
                ${IconWrapper} {
                    display: none;
                }
            }
        }
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};
headerStyles.mainNavigation = {
    css: css`
        width: 100%;
        color: ${color("text.main")};
        background-color: ${color("common.ui8")};
        ${xScreen("lte", "md")} {
            width: auto;
            background: transparent;
        }
    `,
};

headerStyles.topSection = {
    css: css`
        ${TypographyStyle}, ${StyledButton} ${TypographyStyle} {
            color: ${color("common.ui1")};
        }
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

headerStyles.middleSectionContainer = {
    css: css`
        display: flex;
        justify-content: space-between;
        gap: 12px;
        flex-grow: 1;
        width: 100%;
        align-items: center;
        ${xScreen("gt", "lg")} {
            ${layoutContainer}
        }
    `,
};
headerStyles.middleSection = {
    css: css`
        display: flex;
        flex: 1;
        box-shadow: 0 1px 0 0 ${color("common.ui2")};
        padding: 10px 0;
        ${xScreen("lte", "md")} {
            box-shadow: unset;
        }
    `,
};

headerStyles.actionLinks = {
    css: css`
        & > ${DivWrapper} {
            display: flex;
            gap: 36px;
            align-items: center;
        }
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

headerStyles.actions = {
    css: css`
        display: flex;
        gap: 36px;
        justify-content: flex-end;
        & > ${DivWrapper} {
            display: flex;
            gap: 36px;
            align-items: center;
        }
        ${xScreen("lte", "md")} {
            & > ${DivWrapper} {
                gap: 24px;
                justify-content: flex-end;
            }
        }
    `,
};

headerStyles.checkoutWrapper = {
    css: css`
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        gap: 24px;
        padding-block: 10px;
        ${layoutContainer}
        .social-link:hover {
            ${TypographyStyle}, ${IconWrapper} {
                color: ${color("common.brand03")};
            }
        }
    `,
};

headerStyles.printLogo = companyLogoItem;

headerStyles.printLogoImage = {
    css: css`
        max-width: 232px;
        max-height: 68px;
    `,
};
